import { NullChecker } from "./null-checker";
// 1.7763568394002505e-15 -20.4551920341394 40 40
const FLOAT_PATTERN = /[-+]?([\d]+(\.[\d]+(e-[\d]+)?)?|[\d]*(\.[\d]+(e-[\d]+)?))/g;
export function parseAsNumericalArray(input) {
    const arr = [];
    let reg = input.match(FLOAT_PATTERN);
    if (reg && reg.length > 0) {
        reg.forEach(i => arr.push(parseFloat(i)));
    }
    return arr;
}
export class Angle {
    static isAngle(obj) {
        return typeof obj === 'object'
            && 'vertex' in obj && Point.isPoint(obj['vertex'])
            && 'start' in obj && Point.isPoint(obj['start'])
            && 'end' in obj && Point.isPoint(obj['end']);
    }
    /**
     * Returns the angle span in radians.
     * Clockwise angles are positive, counterclockwise angles are negative.
     */
    static value(angle) {
        if (NullChecker.isNullOrEmpty(angle) || !Angle.isAngle(angle)) {
            return Number.NaN;
        }
        const { vertex, start, end } = angle;
        return Angle.angleBetween(vertex, start, end);
    }
    /**
     * Returns the angle (in radians) given the angle vertex and two points belonging to the rays that combine to build the angle sides.
     * Clockwise angles are positive, counterclockwise angles are negative.
     * @param vertex Angle vertex
     * @param start Point belonging to the start side
     * @param end Point belonging to the end side
     * @returns Angle span in radians [-pi, pi]
     */
    static angleBetween(vertex, start, end) {
        const v1 = { x: start.x - vertex.x, y: start.y - vertex.y }, v2 = { x: end.x - vertex.x, y: end.y - vertex.y };
        const dot = v1.x * v2.x + v1.y * v2.y;
        const cross = v1.x * v2.y - v1.y * v2.x;
        // clockwise positive, ccw negative
        return -Math.atan2(cross, dot);
    }
}
;
export class Size {
    static parse(sz) {
        let arr = parseAsNumericalArray(sz);
        if (arr && arr.length === 2) {
            return { width: arr[0], height: arr[1] };
        }
        throw new Error(`Cannot parse "${sz}" as a valid Size.`);
    }
    static isSize(obj) {
        return typeof obj === 'object'
            && 'width' in obj && typeof obj['width'] === 'number'
            && 'height' in obj && typeof obj['height'] === 'number';
    }
}
export class Point {
    static parse(pt) {
        let arr = parseAsNumericalArray(pt);
        if (arr && arr.length === 2) {
            return { x: arr[0], y: arr[1] };
        }
        throw new Error(`Cannot parse "${pt}" as a valid Point.`);
    }
    static isPoint(obj) {
        return typeof obj === 'object'
            && 'x' in obj && typeof obj['x'] === 'number'
            && 'y' in obj && typeof obj['y'] === 'number';
    }
    /**
     * Computes the distance between two points.
     * @param p1 Point 1
     * @param p2 Point 2
     */
    static distance(p1, p2) {
        return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
    }
    /**
     * Subtracts a point p from another and returns the resulting vector.
     * @param p Point to subtract
     * @param from Point to be subtracted from
     */
    static subtract(p, from) {
        return { x: from.x - p.x, y: from.y - p.y };
    }
    /**
     * Adds a set of points together and returns the resulting vector.
     * @param points Points to add
     */
    static add(...points) {
        var point = { x: 0, y: 0 };
        for (var p of points) {
            point.x += p.x;
            point.y += p.y;
        }
        return point;
    }
    /**
     * Memberwise multiplication.
     * @param p Original Point object
     * @param f Factor
     * @returns New Point object.
     */
    static multiply(p, f) {
        return { x: p.x * f, y: p.y * f };
    }
}
//}
